<div class="fc-wrapper">
  <div class="fc-page-header">
    <h4 class="fc-page-title">
      {{ facturaAsociada ? 'Crear Nota de Crédito' : 'Crear Factura' }}
    </h4>
  </div>

  <form [formGroup]="facturaDataFormGroup" (ngSubmit)="onSubmit()">

    <!-- ═══════════════ EMISOR ═══════════════ -->
    <div class="fc-card">
      <div class="fc-card-header">
        <span class="fc-section-num">1</span>
        <span>Datos del Emisor</span>
      </div>

      <div class="fc-card-body">

        <!-- ── Fila 1: Emisor · CUIT · Inicio de actividades ── -->
        <div class="row g-3" *ngIf="!facturaAsociada && terceros == null">
          <div class="col-12 col-md-6">
            <label class="fc-label">
              Emisor <span class="fc-required">*</span>
              <small class="text-muted fw-normal ms-1">Solo emisores guardados en el sistema</small>
            </label>
            <input
              type="text"
              class="form-control form-control-sm mb-1"
              placeholder="Filtrar por CUIT o nombre..."
              [(ngModel)]="filtroListaEmisor"
              [ngModelOptions]="{standalone: true}">
            <div class="d-flex gap-2 align-items-center">
              <select
                class="form-select"
                style="flex:1"
                [(ngModel)]="emisorCuitSeleccionado"
                (ngModelChange)="onEmisorCuitSelected($event)"
                [ngModelOptions]="{standalone: true}"
                [ngClass]="{'is-invalid': validate('emisorNombre')}">
                <option [ngValue]="null" disabled>— Seleccione un emisor —</option>
                <option *ngFor="let e of emisoresFiltrados" [ngValue]="e.cuitNumber">
                  {{ e.cuitNumber }} — {{ e.socialReason }}
                </option>
              </select>
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                (click)="limpiarSeleccionEmisor()"
                *ngIf="emisorCuitSeleccionado"
                ngbTooltip="Limpiar selección">
                <fa-icon [icon]="iconClear"></fa-icon>
              </button>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <label class="fc-label">CUIT del Emisor</label>
            <div class="fc-value fc-value--mono">{{ facturaDataFormGroup.value.cuit || '—' }}</div>
          </div>
          <div class="col-6 col-md-3">
            <label class="fc-label">Inicio de Actividades</label>
            <div class="fc-value">{{ inicioActividadesDisplay }}</div>
          </div>
        </div>

        <!-- ── Fila 1 (terceros) ── -->
        <div class="row g-3" *ngIf="!facturaAsociada && terceros != null">
          <div class="col-12 col-md-6">
            <label class="fc-label">Emisor</label>
            <select class="form-select"
              (change)="updateEmisor($event.target.value)"
              id="emisorNombre"
              [ngModel]="terceros.length == 1 ? 0 : ''"
              [ngModelOptions]="{standalone: true}"
              [ngClass]="{'is-invalid': validate('emisorNombre')}">
              <option [ngValue]="''" disabled>Seleccione un individuo</option>
              <option *ngFor="let tercero of terceros; let ind = index" [value]="ind">
                {{ tercero.fullName }}
              </option>
            </select>
          </div>
          <div class="col-6 col-md-3">
            <label class="fc-label">CUIT</label>
            <div class="fc-value fc-value--mono">{{ facturaDataFormGroup.value.cuit || '—' }}</div>
          </div>
          <div class="col-6 col-md-3">
            <label class="fc-label">Inicio de Actividades</label>
            <div class="input-group">
              <input class="form-control" placeholder="AAAA-MM-DD"
                formControlName="inicioActividades" ngbDatepicker #z="ngbDatepicker"
                [ngClass]="{'is-invalid': validate('inicioActividades')}">
              <button class="btn btn-outline-secondary" (click)="z.toggle()" type="button">
                <fa-icon [icon]="iconCalendar" size="1x"></fa-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- ── Fila 1 (read-only: nota de crédito) ── -->
        <div class="row g-3" *ngIf="facturaAsociada">
          <div class="col-12 col-md-6">
            <label class="fc-label">Emisor</label>
            <div class="fc-value">{{ facturaDataFormGroup.value.emisorNombre || '—' }}</div>
          </div>
          <div class="col-6 col-md-3">
            <label class="fc-label">CUIT</label>
            <div class="fc-value fc-value--mono">{{ facturaDataFormGroup.value.cuit || '—' }}</div>
          </div>
          <div class="col-6 col-md-3">
            <label class="fc-label">Inicio de Actividades</label>
            <div class="fc-value">{{ inicioActividadesDisplay }}</div>
          </div>
        </div>

        <!-- ── Fila 2: Domicilio · Punto de Venta · Tipo de Factura ── -->
        <div class="row g-3 mt-2">
          <div class="col-12 col-md-6">
            <label class="fc-label">Domicilio del Emisor</label>
            <div class="fc-value">{{ facturaDataFormGroup.value.emisorDomicilio || '—' }}</div>
          </div>

          <div class="col-6 col-md-3">
            <label class="fc-label">Punto de Venta</label>
            <div class="fc-value" *ngIf="facturaAsociada">{{ facturaDataFormGroup.value.puntoDeVenta }}</div>
            <input *ngIf="!facturaAsociada"
              placeholder="Ingresar punto de venta"
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              formControlName="puntoDeVenta"
              autocomplete="off"
              class="form-control"
              [ngClass]="{'is-invalid': validate('puntoDeVenta')}">
            <small class="text-muted d-block mt-1" *ngIf="!facturaAsociada">
              Se autocompleta con el valor del emisor, pero podés editarlo.
            </small>
          </div>

          <div class="col-6 col-md-3">
            <label class="fc-label">Tipo de Factura</label>
            <div class="alert alert-warning p-2 mb-0" *ngIf="mostrarCamposRG4004">
              <strong>Factura C</strong> <small class="text-muted">(RG 4004)</small>
            </div>
            <select class="form-select" id="tipoDeFactura" formControlName="tipoDeFactura"
              [ngClass]="{'is-invalid': validate('tipoDeFactura')}"
              *ngIf="!facturaAsociada && terceros == null && !mostrarCamposRG4004">
              <option [value]="''" disabled>Seleccione tipo</option>
              <option *ngFor="let factura of facturaType" [value]="factura.value">{{ factura.text }}</option>
            </select>
            <div class="fc-value" *ngIf="facturaAsociada || terceros != null">{{ facturaTipoTexto ?? notaTipoTexto }}</div>
            <div class="fc-invalid-text"
              *ngIf="validate('tipoDeFactura') && !facturaAsociada && !facturaDataFormGroup.value.tipoDeFactura && !mostrarCamposRG4004">
              Campo requerido
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- ═══════════════ CONSUMIDOR ═══════════════ -->
    <div class="fc-card">
      <div class="fc-card-header">
        <span class="fc-section-num">2</span>
        <span>Datos del Consumidor</span>
      </div>

      <div class="fc-card-body">

        <!-- Buscar consumidor en ARCA -->
        <div class="fc-afip-bar" *ngIf="!facturaAsociada && consumidores.length == 0">
          <label class="fc-label-secondary">Consultar CUIT en ARCA</label>
          <div class="input-group fc-afip-group">
            <input
              type="text"
              class="form-control fc-cuit-input"
              placeholder="CUIT (11 dígitos)"
              [(ngModel)]="cuitBuscadorConsumidor"
              [ngModelOptions]="{standalone: true}"
              maxlength="11"
              (keyup.enter)="buscarConsumidorPorCuit()"
              [disabled]="buscandoCuitConsumidor">
            <button
              class="btn btn-outline-primary"
              type="button"
              (click)="buscarConsumidorPorCuit()"
              [disabled]="buscandoCuitConsumidor || (cuitBuscadorConsumidor?.length ?? 0) < 11">
              <span *ngIf="buscandoCuitConsumidor" class="spinner-border spinner-border-sm me-1"></span>
              <fa-icon *ngIf="!buscandoCuitConsumidor" [icon]="iconSearch" size="sm" class="me-1"></fa-icon>
              {{ buscandoCuitConsumidor ? 'Consultando...' : 'Buscar en ARCA' }}
            </button>
          </div>
        </div>

        <!-- ── Fila 1: Nombre · Domicilio ── -->
        <div class="row g-3">

          <!-- Consumidor editable (typeahead o select) -->
          <div class="col-12 col-md-6" *ngIf="!facturaAsociada">
            <label class="fc-label">
              Nombre del Consumidor <span class="fc-required">*</span>
            </label>

            <!-- Typeahead cuando no hay lista preestablecida -->
            <div *ngIf="consumidores.length == 0">
              <div class="fc-search-row" [ngClass]="{'fc-search-invalid': validate('consumidorNombre')}">
                <input
                  class="form-control fc-search-input"
                  type="text"
                  [(ngModel)]="searchString"
                  [ngModelOptions]="{standalone: true}"
                  (selectItem)="setResult($event)"
                  (blur)="onConsumidorBlur()"
                  [ngbTypeahead]="search"
                  [resultTemplate]="rt"
                  placement="bottom-left"
                  [inputFormatter]="formatResult"
                  [editable]="true"
                  placeholder="Buscar por nombre o CUIT (11 dígitos)...">
                <span *ngIf="searching" class="spinner-border spinner-border-sm text-secondary fc-search-spinner"></span>
                <button
                  type="button"
                  class="fc-search-clear"
                  *ngIf="searchString"
                  (click)="clearSearch()"
                  ngbTooltip="Limpiar">
                  <fa-icon [icon]="iconClear"></fa-icon>
                </button>
              </div>
            </div>

            <!-- Select cuando hay lista preestablecida -->
            <select class="form-select"
              *ngIf="consumidores.length != 0"
              (change)="updateConsumidor($event.target.value)"
              id="consumidorNombre"
              [ngModel]="consumidores.length >= 2 ? 1 : ''"
              [ngModelOptions]="{standalone: true}"
              [ngClass]="{'is-invalid': validate('consumidorNombre')}">
              <option [ngValue]="''" disabled>Seleccione un individuo</option>
              <option *ngFor="let consumidor of consumidores; let ind = index" [value]="ind">
                {{ consumidor.fullName }}
              </option>
            </select>
          </div>

          <!-- Read-only (factura asociada) -->
          <div class="col-12 col-md-6" *ngIf="facturaAsociada">
            <label class="fc-label">Consumidor</label>
            <div class="fc-value">{{ facturaDataFormGroup.value.consumidorNombre || '—' }}</div>
          </div>

          <div class="col-12 col-md-6">
            <label class="fc-label">Domicilio del Consumidor</label>
            <input *ngIf="!facturaAsociada"
              type="text"
              formControlName="consumidorDomicilio"
              class="form-control"
              placeholder="Domicilio del consumidor">
            <div class="fc-value" *ngIf="facturaAsociada">{{ facturaDataFormGroup.value.consumidorDomicilio || '—' }}</div>
          </div>
        </div>

        <!-- ── Fila 2: Tipo Consumidor · Tipo Doc · Nro Doc ── -->
        <div class="row g-3 mt-2">
          <div class="col-12 col-md-3">
            <label class="fc-label">Tipo de Consumidor</label>
            <select *ngIf="!facturaAsociada"
              class="form-select"
              formControlName="consumidorTipo">
              <option *ngFor="let tipo of consumidorTipoOptions" [value]="tipo.value">{{ tipo.label }}</option>
            </select>
            <div class="fc-value" *ngIf="facturaAsociada">
              {{ facturaDataFormGroup.value.consumidorTipo || '—' }}
            </div>
          </div>
          <div class="col-12 col-md-3">
            <label class="fc-label">Tipo de Documento</label>
            <select *ngIf="!facturaAsociada"
              class="form-select"
              formControlName="consumidorDocumentoTipo">
              <option [value]="80">CUIT</option>
              <option [value]="96">DNI</option>
              <option [value]="86">CUIL</option>
              <option [value]="99">Consumidor Final</option>
            </select>
            <div class="fc-value" *ngIf="facturaAsociada">
              {{ getTipoDocumentoConsumidorDisplay() }}
            </div>
          </div>
          <div class="col-12 col-md-6">
            <label class="fc-label">Nro Documento</label>
            <input *ngIf="!facturaAsociada"
              type="text"
              inputmode="numeric"
              formControlName="consumidorDocumentoNumero"
              class="form-control"
              placeholder="Nro documento">
            <div class="fc-value fc-value--mono" *ngIf="facturaAsociada">{{ facturaDataFormGroup.value.consumidorDocumentoNumero || '—' }}</div>
          </div>
        </div>

      </div>
    </div>

    <!-- ═══════════════ DATOS DE LA FACTURA ═══════════════ -->
    <div class="fc-card">
      <div class="fc-card-header">
        <span class="fc-section-num">3</span>
        <span>Datos de la Factura</span>
      </div>

      <div class="fc-card-body">
        <div class="row g-3">

          <div class="col-12 col-md-4">
            <label class="fc-label">Monto Total <span class="fc-required">*</span></label>
            <input *ngIf="!facturaAsociada"
              placeholder="Se calcula desde el detalle"
              type="text"
              formControlName="importeTotal"
              class="form-control"
              [readonly]="true"
              [ngClass]="{'is-invalid': validate('importeTotal')}"
              pattern="[0-9]+([,\.][0-9]+)?">
            <div class="fc-value" *ngIf="facturaAsociada">{{ facturaDataFormGroup.value.importeTotal }}</div>
            <div class="fc-invalid-text" *ngIf="validate('importeTotal') && !facturaAsociada">Campo requerido</div>
            <small class="text-muted" *ngIf="!facturaAsociada">Se actualiza automáticamente con los ítems.</small>
          </div>

          <div class="col-12 col-md-4">
            <label class="fc-label">Fecha de Emisión <span class="fc-required">*</span></label>
            <div class="input-group">
              <input class="form-control" placeholder="AAAA-MM-DD"
                formControlName="fechaEmision" ngbDatepicker #c="ngbDatepicker"
                [minDate]="{year: minDate.getFullYear(), month: minDate.getMonth()+1, day: minDate.getDate()}"
                [maxDate]="{year: maxDate.getFullYear(), month: maxDate.getMonth()+1, day: maxDate.getDate()}"
                [ngClass]="{'is-invalid': validate('fechaEmision')}">
              <button class="btn btn-outline-secondary" (click)="c.toggle()" type="button">
                <fa-icon [icon]="iconCalendar" size="1x"></fa-icon>
              </button>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <label class="fc-label">Fecha de Vencimiento <span class="fc-required">*</span></label>
            <div class="input-group">
              <input class="form-control" placeholder="AAAA-MM-DD"
                formControlName="fechaVencimientoPago" ngbDatepicker #e="ngbDatepicker"
                [minDate]="minFechaVencimiento"
                [ngClass]="{'is-invalid': validate('fechaVencimientoPago')}">
              <button class="btn btn-outline-secondary" (click)="e.toggle()" type="button">
                <fa-icon [icon]="iconCalendar" size="1x"></fa-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- Detalle -->
        <div class="row g-3 mt-1" *ngIf="!facturaAsociada">
          <div class="col-12">
            <label class="fc-label">Detalle de la Factura</label>
            <div class="table-responsive">
              <table class="table table-sm align-middle mb-2">
                <thead>
                  <tr>
                    <th>Producto / Servicio</th>
                    <th style="width: 170px;">Monto</th>
                    <th style="width: 80px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of detalleItems; let i = index">
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        [(ngModel)]="item.detalle"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onDetalleItemChange()"
                        placeholder="Ej: Honorarios administración abril">
                    </td>
                    <td>
                      <input
                        type="text"
                        inputmode="decimal"
                        class="form-control"
                        [ngClass]="{'is-invalid': detalleMontoTieneComa(item)}"
                        [(ngModel)]="item.precioUnitario"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onDetalleItemChange()">
                      <div class="invalid-feedback d-block" *ngIf="detalleMontoTieneComa(item)">
                        Corregí el monto: usá punto en lugar de coma (ej: 1234.56).
                      </div>
                    </td>
                    <td>
                      <button type="button" class="btn btn-sm btn-outline-danger" (click)="eliminarDetalleItem(i)">
                        Quitar
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="3">
                      <button type="button" class="btn btn-sm btn-outline-primary" (click)="agregarDetalleItem()">
                        + Agregar ítem
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-end fw-semibold">Total</td>
                    <td class="fw-bold">{{ totalDetalleFactura | number:'1.2-2' }}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <!-- Importes IVA (solo Responsable Inscripto) -->
        <div *ngIf="taxRole == 2 && !mostrarCamposRG4004">
          <hr class="fc-divider">
          <div class="fc-subsection-title">Desglose IVA (Responsable Inscripto)</div>
          <div class="row g-3">
            <div class="col-6 col-md-3">
              <label class="fc-label">Importe Exento</label>
              <input placeholder="0,00" type="text" formControlName="importeExento" class="form-control"
                [ngClass]="{'is-invalid': validate('importeExento')}"
                (blur)="normalizeNumberInput('importeExento')" pattern="[0-9]+([,\.][0-9]+)?">
            </div>
            <div class="col-6 col-md-3">
              <label class="fc-label">Importe Gravado</label>
              <input placeholder="0,00" type="text" formControlName="importeGravado" class="form-control"
                [ngClass]="{'is-invalid': validate('importeGravado')}"
                (blur)="normalizeNumberInput('importeGravado')" pattern="[0-9]+([,\.][0-9]+)?">
            </div>
            <div class="col-6 col-md-3">
              <label class="fc-label">Importe IVA</label>
              <input placeholder="0,00" type="text" formControlName="importeIva" class="form-control"
                [ngClass]="{'is-invalid': validate('importeIva')}"
                (blur)="normalizeNumberInput('importeIva')" pattern="[0-9]+([,\.][0-9]+)?">
            </div>
            <div class="col-6 col-md-3">
              <label class="fc-label">Tipo de IVA</label>
              <select class="form-select" id="iVATipoId" formControlName="iVATipoId"
                [ngClass]="{'is-invalid': validate('iVATipoId')}">
                <option [value]="3">0%</option>
                <option [value]="4">10.5%</option>
                <option [value]="5">21%</option>
                <option [value]="6">27%</option>
                <option [value]="8">5%</option>
                <option [value]="9">2.5%</option>
              </select>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- ═══════════════ RG 4004 (condicional) ═══════════════ -->
    <div class="fc-card fc-card--warn" *ngIf="mostrarCamposRG4004">
      <div class="fc-card-header fc-card-header--warn">
        <span class="fc-section-num fc-section-num--warn">⚖</span>
        <span>RG 4004 — Facturación por cuenta y orden de terceros</span>
      </div>
      <div class="fc-card-body">
        <div class="row g-3">
          <div class="col-12 col-md-4">
            <label class="fc-label" for="propietarioCuit">
              CUIT del propietario <span class="fc-required">*</span>
              <small class="text-muted fw-normal">11 dígitos</small>
            </label>
            <input type="text" id="propietarioCuit" class="form-control"
              formControlName="propietarioCuit" placeholder="20999888777" maxlength="11"
              [ngClass]="{'is-invalid': validarCampoRG4004('propietarioCuit')}">
            <div class="mt-1" *ngIf="facturaDataFormGroup.get('propietarioCuit')?.value">
              <small class="d-flex align-items-center gap-1">
                <span class="spinner-border spinner-border-sm" *ngIf="validandoCuitTercero"></span>
                <span
                  [class.text-success]="cuitTerceroValido && !validandoCuitTercero"
                  [class.text-danger]="!cuitTerceroValido && !validandoCuitTercero">
                  {{ mensajeValidacionCuit }}
                </span>
              </small>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <label class="fc-label" for="propietarioNombre">
              Nombre / Razón Social <span class="fc-required">*</span>
            </label>
            <input type="text" id="propietarioNombre" class="form-control"
              formControlName="propietarioNombre" placeholder="Juan Pérez / Empresa SA"
              [ngClass]="{'is-invalid': validarCampoRG4004('propietarioNombre')}">
          </div>
          <div class="col-12 col-md-4">
            <label class="fc-label" for="tipoFacturacion">Tipo de Facturación</label>
            <select class="form-select" id="tipoFacturacion" formControlName="tipoFacturacion">
              <option [value]="1">Por intermediario (recomendado)</option>
              <option [value]="2">Facturación directa</option>
            </select>
            <small class="text-muted">Para administración de propiedades usar «Por intermediario»</small>
          </div>
        </div>
      </div>
    </div>

    <!-- ═══════════════ FACTURA ASOCIADA ═══════════════ -->
    <div class="fc-card" *ngIf="facturaAsociada">
      <div class="fc-card-header">
        <span class="fc-section-num">↩</span>
        <span>Factura Asociada</span>
      </div>
      <div class="fc-card-body">
        <div class="row g-3">
          <div class="col-4">
            <label class="fc-label">Tipo</label>
            <div class="fc-value">{{ notaFacturaTexto }}</div>
          </div>
          <div class="col-4">
            <label class="fc-label">Punto de Venta</label>
            <div class="fc-value">{{ facturaDataFormGroup.value.pdvAsociado }}</div>
          </div>
          <div class="col-4">
            <label class="fc-label">Nro. Comprobante</label>
            <div class="fc-value">{{ facturaDataFormGroup.value.numeroFacturaAsociado }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- ═══════════════ BOTONES ═══════════════ -->
    <div class="fc-actions">
      <button type="button" class="btn btn-outline-secondary" [disabled]="submitted" (click)="cancel()">
        Cancelar
      </button>
      <button class="btn btn-primary fc-submit-btn" [disabled]="submitted">
        <span *ngIf="submitted" class="spinner-border spinner-border-sm me-2"></span>
        {{ mostrarCamposRG4004 ? 'Crear Factura RG 4004' : (facturaAsociada ? 'Crear Nota de Crédito' : 'Crear Factura') }}
      </button>
    </div>

  </form>
</div>

<!-- Typeahead result template -->
<ng-template #rt let-r="result" let-t="term">
  <div class="fc-typeahead-item">
    <fa-icon [icon]="iconSearch" size="sm" class="text-muted me-2"></fa-icon>
    <ngb-highlight [result]="formatResult(r, false)" [term]="t"></ngb-highlight>
  </div>
</ng-template>

<!-- Modal: alta CUIT/Emisor (puede venir precargado desde AFIP) -->
<ng-template #cuitFormTemplate>
  <div class="p-3">
    <app-cuit-form
      [edit]="false"
      [initialDraft]="cuitFormInitialDraft"
      (closeAction)="closeCuitForm()"
      (cancelAction)="cancelCuitForm()">
    </app-cuit-form>
  </div>
</ng-template>
